import { render, staticRenderFns } from "./hospitalReportsPage.html?vue&type=template&id=0cd94af4&"
import script from "./hospitalReportsPage.vue?vue&type=script&lang=js&"
export * from "./hospitalReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports